<template>
  <div class="OddColumnHeader-styles-header">
    <div v-for="l in label" v-if="label" class="OddColumnHeader-styles-header-item notranslate">
      {{ l.outcome }}</div>
  </div>

  <!--
  <div class="OddColumnHeader-styles-header OddColumnHeader-styles-thin">
    <div class="OddColumnHeader-styles-header-item">+</div>
    <div class="OddColumnHeader-styles-header-item">-</div>
  </div> !-->
</template>

<script>
export default {
  name: 'marketLabel',
  props: ['id', 'onLive'],
  data () {
    return {
      label: null,
    }
  },
  watch: {
    '$store.state.marketSelect' (v) {
      if(v.cell == this.id && v.onLive == this.onLive)
        this.label = v.market.outcomes;
    },
  },
  mounted() {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/marketLabel.vue